<template>
  <v-row>
    <v-col cols="12">
      <div class="text-h5 mb-5">{{ $t("admin.users") }}</div>
      <v-card>
        <v-card-text>
          <v-text-field
            v-model="search"
            dense
            outlined
            hide-details
            clearable
            prepend-inner-icon="fas fa-search"
            :label="$t('admin.searchUser')"
            class="mb-3"
          ></v-text-field>
          <v-data-table
            :headers="headers"
            :items="users"
            :server-items-length="totalCount"
            :options.sync="options"
            :loading="loading"
            :footer-props="{ 'items-per-page-options': [10, 25, 100] }"
            disable-sort
            class="elevation-1"
            no-data-text="Brak użytkowników do wyświetlenia"
          >
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                icon
                small
                color="primary"
                :title="$t('admin.goToBets')"
                @click="GoToUserBets(item.userId)"
              >
                <v-icon small>fas fa-hand-holding-usd</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import AdminService from "@/services/AdminService.js";

export default {
  name: "AdminUsersView",
  data() {
    return {
      users: [],
      totalCount: 0,
      search: "",
      loading: false,
      searchTimer: null,
      options: { page: 1, itemsPerPage: 10 },
      headers: [
        { text: "Login", value: "login" },
        { text: "Email", value: "email" },
        {
          text: this.$t("admin.actions"),
          value: "actions",
          sortable: false,
          align: "end",
          width: "80px",
        },
      ],
    };
  },
  watch: {
    // Zmiana strony / rozmiaru strony (v-data-table emituje update:options także na starcie).
    options: {
      handler() {
        this.$_loadUsers();
      },
      deep: true,
    },
    // Wyszukiwanie z debounce - reset do pierwszej strony; podmiana options wyzwoli jedno pobranie.
    search() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.options = { ...this.options, page: 1 };
      }, 700);
    },
  },
  methods: {
    GoToUserBets(userId) {
      this.$router
        .push({ name: "AdminUserBets", params: { userId } })
        .catch(() => {});
    },
    async $_loadUsers() {
      try {
        this.loading = true;
        const response = await AdminService.GetUsers({
          page: this.options.page,
          pageSize: this.options.itemsPerPage,
          search: this.search || "",
        });
        const result = response.data;
        if (result.success) {
          this.users = result.data.items;
          this.totalCount = result.data.totalCount;
        }
      } catch (err) {
        //
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
